import { TokenTypes } from '../store';
import { BaseService, RequestMethod } from './BaseService';

export interface SendMessageApiOptions {
  readonly tokenType?: TokenTypes;
  readonly sign?: boolean;
}

export namespace ConnectApiService {

  export class Api extends BaseService {

    constructor() {
      super({ configPath: 'services.connectApi' });
    }

    /**
     *
     * @returns
     */
    async sendMessage(channelId: string, message: Record<string, unknown>, options:SendMessageApiOptions = {}): Promise<any> {
      return this.requestResource('sendMessage', {
        method: RequestMethod.PUT,
        data: message,
        params: { channelId },
        ...options,
      });
    }

    /**
     *
     * @returns
     */
    async adminSendMessage(channelId: string, message: Record<string, unknown>): Promise<any> {
      return this.requestResource('adminSendMessage', {
        method: RequestMethod.PUT,
        data: message,
        params: { channelId },
        tokenType: 'none',
        sign: true,
      });
    }

    /**
     *
     * @returns
     */
    async createChannel(channelAttributes: IChannelCreateOptions): Promise<any> {
      return this.requestResource('createChannel', {
        method: RequestMethod.POST,
        tokenType: 'none',
        data: channelAttributes as unknown as Record<string, unknown>,
        sign: true,
      });
    }
  }
}
export interface IChannelCreateOptions {
  readonly channelAttributes: {
    [key: string]: string;
  };
  readonly messageAttributes: { // will be sent along with MessageAttributes in SNS message
    ['SANS.CONNECT.APPLICATION']: string;
    [key: string]: string;
  };
}

export default ConnectApiService.Api;
